// src/components/UI/LoadingSpinner.js
import React from 'react';

const LoadingSpinner = ({ size = 'medium', text = 'Loading...' }) => {
  const sizeClasses = {
    small: 'w-6 h-6 border-3',
    medium: 'w-12 h-12 border-4', 
    large: 'w-16 h-16 border-6'
  };

  return (
    <div className="flex flex-col items-center justify-center p-4">
      <div className={`rounded-full border-solid border-gray-200 border-t-blue-600 animate-spin ${sizeClasses[size]}`}></div>
      {text && <p className="mt-3 text-gray-600">{text}</p>}
    </div>
  );
};

export default LoadingSpinner;